module.exports = __webpack_public_path__ + "static/images/components/WGCWXConfirmation/images/error.7fa92cf5.png";


//////////////////
// WEBPACK FOOTER
// ./components/WGCWXConfirmation/images/error.png
// module id = 2731
// module chunks = 11